import moment from 'moment-timezone';
import getItemStyles from '../../../utils/item-styles';
import getOffsetTime from '../../../../../utils/getOffsetTime';
import timelineDisplayOrder from './timelineDisplayOrder';
import daylightSavingsCheck from '../../../../../utils/daylightSavingsCheck';

/**
 * Returns an on-call assignment (referred to as dayType assignment in the html and xml parsers)
 * item that can be displayed in the 1 to 2 day posted schedule.
 * @param {*} resource
 * @param {*} dayType
 */
const generateAssignment = (resource, dayType, scheduleFormat) => {
  const { rId } = resource;
  const { rdtId, assignment } = dayType;
  const { startTime, endTime, jeId, jobId, requestNumber, costObject, service, status, comment, description, myAssignmentComment } = assignment;
  const assignStartTime = moment.unix(startTime);
  const offset = 0;//getOffsetTime(assignStartTime._d);
  assignStartTime.add(offset, 'minutes');
  const assignEndTime = moment.unix(endTime).add(offset, 'minutes');
  let style;
  if (assignment && assignment.reconciled === '1') {
    style = getItemStyles(4);
  } else if (assignment.status === '20') {
    style = getItemStyles(5);
  } else {
    style = getItemStyles(3);
  }

  let hasComment = false;
  if (comment || description || myAssignmentComment) {
    hasComment = true;
  }
  
  return {
    id: jeId,
    jobId,
    requestNumber,
    itemType: 'assignment',
    group: rId,
    start_time: assignStartTime,
    end_time: assignEndTime,
    title: costObject + ' / ' + service,
    rdtId,
    status,
    backgroundColor: style.backgroundColor,
    color: style.color,
    borderStyle: style.borderStyle,
    borderColor: !hasComment ? style.borderColor : "red",
    timelineDisplayOrder: timelineDisplayOrder.assignment,
    resourceClass: resource.class
  };
}

export default generateAssignment;



// WEBPACK FOOTER //
// ./src/Components/Schedule/OneTwoDay/utils/generate-timeline/generateAssignment.js